/**
 * Module: components/atoms/WizardCtaBar
 * Role: Shared sticky-bottom CTA wrapper over PressBtn.
 * Uses: PressBtn, tokens (P)
 * Used by: creator/_chrome/WizardShell, screens/flow/templates/*, screens/flow/bricks/*
 * Glossary: ai/glossary/buyer.md
 */
import { PressBtn } from './PressBtn';
import { P } from '../../styles/tokens';

export interface WizardCtaBarProps {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** `'terra'` (default) = brand CTA. `'ink'` = secondary. */
  kind?: 'terra' | 'ink';
}

export function WizardCtaBar({
  label, onClick, disabled, kind = 'terra',
}: WizardCtaBarProps) {
  const bg = kind === 'terra' ? P.terracotta : P.ink;
  return (
    <div
      style={{
        padding: '10px 16px 20px',
        flexShrink: 0,
        paddingBottom: 'calc(20px + var(--tg-safe-area-inset-bottom, 0px))',
      }}
    >
      <PressBtn
        bg={bg}
        fg="#ffffff"
        onClick={onClick}
        disabled={disabled}
        size="lg"
      >
        {label}
      </PressBtn>
    </div>
  );
}
